<template>
  <div class="componentSty">
    <m-title :titlelist="listitem"></m-title>
    <div class="componentSty_content">
      <div class="componentSty_content_title">
        <span class="fonints">状态</span>
        <div class="select_box">
          <m-select
            :list="selectastrict"
            :value="conditions.type"
            @input="chanval"
          ></m-select>
        </div>
        <span class="fonints">选择日期</span>
        <el-date-picker
          v-model="conditions.datatime"
          type="date"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
          placeholder="选择日期"
        >
        </el-date-picker>
        <button class="buttons" @click="queryTableInfo">查询</button>
        <el-upload
          style="display: inline-block"
          action="#"
          :show-file-list="false"
          :before-upload="beforeAvatarUpload"
          :http-request="uploadfile"
        >
          <button class="buttons" style="background: orange; width: 180px">
            {{ filename ? "重选文件对账" : "上传文件对账" }}
          </button>
        </el-upload>
        <div class="texthidden" v-show="filename">
          当前文件:
          <span style="color: #17B6A1">{{ filename }}</span>
        </div>
      </div>

      <div class="componentSty_content_table" style="border:none">
        <el-table style="width: 100%; height: 80%" border  height="80%" :data="arrlist.data">
          <el-table-column show-overflow-tooltip
            label="序号"
            type="index"
            width="50px"
          ></el-table-column>
          <el-table-column show-overflow-tooltip prop="paytime" label="交易时间"> </el-table-column>
          <el-table-column show-overflow-tooltip prop="accesstype" label="收单接入方式">
          </el-table-column>
          <el-table-column show-overflow-tooltip prop="thname" label="第三方支付名称">
          </el-table-column>
          <el-table-column show-overflow-tooltip prop="type" label="交易类型"> </el-table-column>
          <el-table-column show-overflow-tooltip prop="shopname" label="商品名称"> </el-table-column>
          <el-table-column show-overflow-tooltip prop="orderamount" label="订单金额">
          </el-table-column>
          <el-table-column show-overflow-tooltip prop="icbcorderid" label="工行订单号">
          </el-table-column>
          <el-table-column show-overflow-tooltip prop="outtradeno" label="商户订单号">
          </el-table-column>
          <el-table-column show-overflow-tooltip prop="lscode" label="商户退款流水号">
          </el-table-column>
          <el-table-column show-overflow-tooltip prop="source" label="账单来源"> </el-table-column>
        </el-table>
        <div class="msgstatistics">
          <span>本系统总金额:{{ arrlist.bensum }}</span>
          <span>ICBC总金额:{{ arrlist.icbcsum }}</span>
        </div>
        <div class="paginations" v-show="arrlist.data && isquery">
          <el-pagination
            :page-size="conditions.limit"
           layout="total,prev, pager,next, jumper"
            :total="arrlist.count"
            :current-page="conditions.page"
            @current-change="handleCurrentChange"
          >
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import mTitle from "@/components/mTitle";
import mSelect from "@/components/mSelect";
import { antiShake } from "@/plugins/other.js";
export default {
  data() {
    return {
      listitem: [{ name: "财务管理" }, { name: "财务对账" }],
      selectastrict: ["全部账单", "支付账单", "退款账单"],
      conditions: {
        page: 1,
        limit: 20,
        datatime: "",
        type: "全部账单",
      },
      arrlist: [],
      isquery: true,
      filename: "",
    };
  },
  components: {
    mTitle,
    mSelect,
  },
  methods: {
    // 获取列表页面
    async gainTableList() {
      this.isquery = true;
      if (!this.conditions.datatime) return this.$message.error("请选择日期");
      const { data } = await this.$http(
        "api1",
        "/csvanalysis/csv/bill",
        "get",
        this.conditions
      );
      if (data.code != 0) return this.$message.error(data.msg);
      this.arrlist = data;
    },
    handleCurrentChange(index) {
      if (this.arrlist.totalCount < this.conditions.limit) return;
      this.conditions.page = index;
      this.gainTableList();
    },
    // 上传文件前钩子
    beforeAvatarUpload(file) {
      let type =
          file.type ===
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
          file.type === "application/vnd.ms-excel",
        size = file.size / 1024 / 1024 < 30;
      if (!type) {
        this.$message.error("请选择excel文件");
        return false;
      }
      if (!size) {
        this.$message.error("上传大小不能超过30M");
        return false;
      }
      return type && size;
    },
    // 上传文件对账
    async uploadfile(res) {
      this.isquery = false;
      if (!this.conditions.datatime) return this.$message.error("请选择日期");
      this.filename = res.file.name;
      const file = new FormData();
      file.append("multipartFile", res.file);
      file.append("datatime", this.conditions.datatime);
      file.append("type", this.conditions.type);
      file.append('flag', "357779a88b0b5ab0c9b2b061cac69672");
      const { data } = await this.$http(
        "api1",
        "/csvanalysis/csv/CsvReconciliation",
        "post",
        file
      );
      if (data.code != 0) return this.$message.error(data.msg);
      this.arrlist = data;
    },
    // 查询按钮
    queryTableInfo() {
      antiShake((_) => {
        this.conditions.page;
        this.gainTableList();
      });
    },
    chanval(event) {
      this.conditions.type = event;
      this.gainTableList();
    },
  },
};
</script>
<style lang="scss" src="@/assets/components.scss" scoped></style>